import FlowCanvas from "./components/Canvas";
import "./styles.css";

export default function App() {
  return <FlowCanvas />;
}